import React from 'react'

const Jv_que = () => {
    return (
        <div className='container'>
  <td>
      

      <h1 class="h1">Java Queue Interface</h1>
      <p>Java Queue interface orders the element in FIFO(First In First Out) manner. In FIFO, first element is removed
            first and last element is removed at last.</p>
      <h3 class="h3">Queue Interface declaration</h3>
      <div class="containers">
            <div class="dp-highlighter">
                  
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">interface</span><span>&nbsp;Queue&lt;E&gt;&nbsp;</span><span
                                          class="keyword">extends</span><span>&nbsp;Collection&lt;E&gt;&nbsp;&nbsp;</span></span>
                        </li>
                  </ul>
            </div>
      </div>
      <h3 class="h3">Methods of Java Queue Interface</h3>
      <table class="alt">
            <tbody>
                  <tr>
                        <th>Method</th>
                        <th>Description</th>
                  </tr>
                  <tr>
                        <td>boolean add(object)</td>
                        <td>It is used to insert the specified element into this queue and return true upon success.
                        </td>
                  </tr>
                  <tr>
                        <td>boolean offer(object)</td>
                        <td>It is used to insert the specified element into this queue.</td>
                  </tr>
                  <tr>
                        <td>Object remove()</td>
                        <td>It is used to retrieves and removes the head of this queue.</td>
                  </tr>
                  <tr>
                        <td>Object poll()</td>
                        <td>It is used to retrieves and removes the head of this queue, or returns null if this queue is
                              empty.</td>
                  </tr>
                  <tr>
                        <td>Object element()</td>
                        <td>It is used to retrieves, but does not remove, the head of this queue.</td>
                  </tr>
                  <tr>
                        <td>Object peek()</td>
                        <td>It is used to retrieves, but does not remove, the head of this queue, or returns null if
                              this queue is empty.</td>
                  </tr>
            </tbody>
      </table>
      <hr/>
      <h2 class="h2">PriorityQueue class</h2>
      <p>The PriorityQueue class provides the facility of using queue. But it does not orders the elements in FIFO
            manner. It inherits AbstractQueue class.
      </p>
      <h3 class="h3">PriorityQueue class declaration</h3>
      <p>Let's see the declaration for java.util.PriorityQueue class.</p>
      <div class="containers">
            <div class="dp-highlighter">
                  
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">class</span><span>&nbsp;PriorityQueue&lt;E&gt;&nbsp;</span><span
                                          class="keyword">extends</span><span>&nbsp;AbstractQueue&lt;E&gt;&nbsp;</span><span
                                          class="keyword">implements</span><span>&nbsp;Serializable&nbsp;&nbsp;</span></span>
                        </li>
                  </ul>
            </div>
      </div>
      <h3 class="h3">Java PriorityQueue Example</h3>
      <div class="containers">
            <div class="dp-highlighter">
                  
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keyword">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span
                                          class="keyword">class</span><span>&nbsp;TestCollection12&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span><span class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">static</span><span>&nbsp;</span><span
                                          class="keyword">void</span><span>&nbsp;main(String&nbsp;args[])&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>PriorityQueue&lt;String&gt;&nbsp;queue=<span
                                          class="keyword">new</span><span>&nbsp;PriorityQueue&lt;String&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>queue.add(<span
                                          class="string">"Amit"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>queue.add(<span
                                          class="string">"Vijay"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>queue.add(<span
                                          class="string">"Karan"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>queue.add(<span class="string">"Jai"</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>queue.add(<span
                                          class="string">"Rahul"</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>System.out.println(<span
                                          class="string">"head:"</span><span>+queue.element());&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>System.out.println(<span
                                          class="string">"head:"</span><span>+queue.peek());&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>System.out.println(<span
                                          class="string">"iterating&nbsp;the&nbsp;queue&nbsp;elements:"</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>Iterator&nbsp;itr=queue.iterator();&nbsp;&nbsp;</span></li>
                        <li class=""><span><span
                                          class="keyword">while</span><span>(itr.hasNext())&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>System.out.println(itr.next());&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>queue.remove();&nbsp;&nbsp;</span></li>
                        <li class=""><span>queue.poll();&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>System.out.println(<span
                                          class="string">"after&nbsp;removing&nbsp;two&nbsp;elements:"</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>Iterator&lt;String&gt;&nbsp;itr2=queue.iterator();&nbsp;&nbsp;</span></li>
                        <li class="alt"><span><span
                                          class="keyword">while</span><span>(itr2.hasNext())&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>System.out.println(itr2.next());&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  </ul>
            </div>
      </div>
      
      <div class="output">
            <pre>Output:head:Amit <br/>
             head:Amit <br/>
             iterating the queue elements: <br/>
             Amit <br/>
             Jai <br/>
             Karan <br/>
             Vijay <br/>
             Rahul <br/>
             after removing two elements: <br/>
             Karan <br/>
             Rahul <br/>
             Vijay <br/>
      </pre>
      </div>
      <h3 class="h3">Java PriorityQueue Example: Book</h3>
      <p>Let's see a PriorityQueue example where we are adding books to queue and printing all the books. The elements
            in PriorityQueue must be of Comparable type. String and Wrapper classes are Comparable by default. To add
            user-defined objects in PriorityQueue, you need to implement Comparable interface.</p>
      <div class="containers">
            <div class="dp-highlighter">
                  
                  <ul start="1" class="dp-j">
                        <li class="alt"><span><span
                                          class="keyword">import</span><span>&nbsp;java.util.*;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keyword">class</span><span>&nbsp;Book&nbsp;</span><span
                                          class="keyword">implements</span><span>&nbsp;Comparable&lt;Book&gt;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span><span class="keyword">int</span><span>&nbsp;id;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>String&nbsp;name,author,publisher;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span><span
                                          class="keyword">int</span><span>&nbsp;quantity;&nbsp;&nbsp;</span></span></li>
                        <li class=""><span><span class="keyword">public</span><span>&nbsp;Book(</span><span
                                          class="keyword">int</span><span>&nbsp;id,&nbsp;String&nbsp;name,&nbsp;String&nbsp;author,&nbsp;String&nbsp;publisher,&nbsp;</span><span
                                          class="keyword">int</span><span>&nbsp;quantity)&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">this</span><span>.id&nbsp;=&nbsp;id;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">this</span><span>.name&nbsp;=&nbsp;name;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">this</span><span>.author&nbsp;=&nbsp;author;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">this</span><span>.publisher&nbsp;=&nbsp;publisher;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">this</span><span>.quantity&nbsp;=&nbsp;quantity;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span><span class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">int</span><span>&nbsp;compareTo(Book&nbsp;b)&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">if</span><span>(id&gt;b.id)&#123;&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">return</span><span>&nbsp;</span><span
                                          class="number">1</span><span>;&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;<span
                                          class="keyword">else</span><span>&nbsp;</span><span
                                          class="keyword">if</span><span>(id&lt;b.id)&#123;&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">return</span><span>&nbsp;-</span><span
                                          class="number">1</span><span>;&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;<span
                                          class="keyword">else</span><span>&#123;&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">return</span><span>&nbsp;</span><span
                                          class="number">0</span><span>;&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span><span class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">class</span><span>&nbsp;LinkedListExample&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span><span class="keyword">public</span><span>&nbsp;</span><span
                                          class="keyword">static</span><span>&nbsp;</span><span
                                          class="keyword">void</span><span>&nbsp;main(String[]&nbsp;args)&nbsp;&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;Queue&lt;Book&gt;&nbsp;queue=<span
                                          class="keyword">new</span><span>&nbsp;PriorityQueue&lt;Book&gt;();&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Creating&nbsp;Books</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;Book&nbsp;b1=<span
                                          class="keyword">new</span><span>&nbsp;Book(</span><span
                                          class="number">121</span><span>,</span><span
                                          class="string">"Let&nbsp;us&nbsp;C"</span><span>,</span><span
                                          class="string">"Yashwant&nbsp;Kanetkar"</span><span>,</span><span
                                          class="string">"BPB"</span><span>,</span><span
                                          class="number">8</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;Book&nbsp;b2=<span
                                          class="keyword">new</span><span>&nbsp;Book(</span><span
                                          class="number">233</span><span>,</span><span
                                          class="string">"Operating&nbsp;System"</span><span>,</span><span
                                          class="string">"Galvin"</span><span>,</span><span
                                          class="string">"Wiley"</span><span>,</span><span
                                          class="number">6</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;Book&nbsp;b3=<span
                                          class="keyword">new</span><span>&nbsp;Book(</span><span
                                          class="number">101</span><span>,</span><span
                                          class="string">"Data&nbsp;Communications&nbsp;&amp;&nbsp;Networking"</span><span>,</span><span
                                          class="string">"Forouzan"</span><span>,</span><span
                                          class="string">"Mc&nbsp;Graw&nbsp;Hill"</span><span>,</span><span
                                          class="number">4</span><span>);&nbsp;&nbsp;</span></span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Adding&nbsp;Books&nbsp;to&nbsp;the&nbsp;queue</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;queue.add(b1);&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;queue.add(b2);&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;queue.add(b3);&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"Traversing&nbsp;the&nbsp;queue&nbsp;elements:"</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="comment">//Traversing&nbsp;queue&nbsp;elements</span><span>&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">for</span><span>(Book&nbsp;b:queue)&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(b.id+<span
                                          class="string">"&nbsp;"</span><span>+b.name+</span><span
                                          class="string">"&nbsp;"</span><span>+b.author+</span><span
                                          class="string">"&nbsp;"</span><span>+b.publisher+</span><span
                                          class="string">"&nbsp;"</span><span>+b.quantity);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;queue.remove();&nbsp;&nbsp;</span></li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(<span
                                          class="string">"After&nbsp;removing&nbsp;one&nbsp;book&nbsp;record:"</span><span>);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;<span
                                          class="keyword">for</span><span>(Book&nbsp;b:queue)&#123;&nbsp;&nbsp;</span></span>
                        </li>
                        <li class=""><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System.out.println(b.id+<span
                                          class="string">"&nbsp;"</span><span>+b.name+</span><span
                                          class="string">"&nbsp;"</span><span>+b.author+</span><span
                                          class="string">"&nbsp;"</span><span>+b.publisher+</span><span
                                          class="string">"&nbsp;"</span><span>+b.quantity);&nbsp;&nbsp;</span></span>
                        </li>
                        <li class="alt"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;&nbsp;&nbsp;</span></li>
                        <li class=""><span>&#125;&nbsp;&nbsp;</span></li>
                        <li class="alt"><span>&#125;&nbsp;&nbsp;</span></li>
                  </ul>
            </div></div>
            <p>Output:</p>
            <div class="output">
                  <pre>Traversing the queue elements: <br />
      101 Data Communications &amp; Networking Forouzan Mc Graw Hill 4 <br />
      233 Operating System Galvin Wiley 6 <br />
      121 Let us C Yashwant Kanetkar BPB 8 <br />
      After removing one book record: <br />
      121 Let us C Yashwant Kanetkar BPB 8 <br />
      233 Operating System Galvin Wiley 6 <br />
      </pre>
            
            </div>
            </td>
            </div>


    )
}

export default Jv_que
